import Effects from 'Effects';
import {isMobile} from 'react-device-detect';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AbstractParameter,
        } from 'parameters/AbstractParameter.js';

class SoftClipperEffect extends Effects.Effect {

    constructor(sequencerEngine) {
        super('Soft Clipper', () => new Tone.Gain(1) , sequencerEngine, true);; 
        this.outputNode = new Tone.Gain(1);
        this.amountParameter = new AbstractParameter(
            'Amount', this, (o, x) => this.softClipper ? this.softClipper.parameters.get("amount").value = x : this.effectNode.gain.value = x, {
                documentation: "Controls the amount of soft clipping",
                min: 0,
                max: 8,
                defaultValue: 1
            });
        this.registerParameter(this.amountParameter);
        this.loadedValue = 1;
        this.initializeWorklets();
        this.updateInitialValues();
   }

    connect(o) {
        this.outputNode.connect(o);
    }

    disconnect(o) {
        this.outputNode.disconnect(o);
    }

    async initializeWorklets() {
        if (isMobile || this.sequencerEngine.isOffline) {
            // then we dont do anything just connec the the input to output
            this.effectNode.connect(this.outputNode);
        } else {
            await this.sequencerEngine.initAudioWorklets();
            this.softClipper = new AudioWorkletNode(Tone.Master.context._context, 'soft-clipper-node');
            this.amountParameter.set(this.loadedValue, false, false);
            this.effectNode.connect(this.softClipper);
            this.softClipper.connect(this.outputNode);
        }
       this.updateInitialValues();
    }

    get documented() {
        return "Reduces the volume of loud sounds or amplifies quiet sounds.";
    }

    getJson(isPreset) {
        let json = super.getJson();
        json.amount = this.amountParameter.get();
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        if (json.amount) {
            this.loadedValue = json.amount;
            let {id, value} = this.amountParameter.set(json.amount, false, false);
            bulk[id] = value;
        }
        return bulk;
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new SoftClipperEffect(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default SoftClipperEffect;
